/**
 * Расписание психолога
 * Визуальная сетка часы × дни с управлением доступностью
 */
const PsySchedule = {
	moduleId: 8,
	currentWeekStart: null,
	currentFormat: 'онлайн',

	// Drag selection
	isDragging: false,
	dragStartCell: null,
	selectedCells: [],

	/**
	 * Инициализация
	 */
	init: function() {
		const container = document.querySelector('[data-psy-schedule-module-id]');
		if (!container) return;

		//this.moduleId = container.dataset.psyScheduleModuleId;
		this.currentWeekStart = container.dataset.weekStart || this.getMondayOfWeek(new Date());
		this.currentFormat = container.dataset.format || 'офлайн';

		this.bindEvents();
		this.loadWeekData();
	},

	/**
	 * Привязка событий
	 */
	bindEvents: function() {
		// Переключение формата
		document.querySelectorAll('[data-psy-schedule-format]').forEach(el => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				this.switchFormat(el.dataset.psyScheduleFormat);
			});
		});

		// Навигация по неделям
		document.querySelector('[data-psy-schedule-prev]')?.addEventListener('click', () => this.prevWeek());
		document.querySelector('[data-psy-schedule-next]')?.addEventListener('click', () => this.nextWeek());
		document.querySelector('[data-psy-schedule-today]')?.addEventListener('click', () => this.goToCurrentWeek());

		// Закрытие попапа — по крестику и по клику на фон (wrapper)
		document.querySelectorAll('.popup-psy-availability .popup__close').forEach(el => {
			el.addEventListener('click', () => this.closePopups());
		});
		document.querySelectorAll('.popup-psy-availability .popup__wrapper').forEach(el => {
			el.addEventListener('click', (e) => {
				// Закрываем только при клике на сам wrapper, не на контент внутри
				if (e.target === el) this.closePopups();
			});
		});

		// Форма доступности
		const form = document.getElementById('psy-availability-form');
		if (form) {
			form.addEventListener('submit', (e) => {
				e.preventDefault();
				this.saveAvailability(form);
			});
		}
	},

	/**
	 * Получить понедельник недели
	 */
	getMondayOfWeek: function(date) {
		const d = new Date(date);
		const day = d.getDay();
		const diff = d.getDate() - day + (day === 0 ? -6 : 1);
		d.setDate(diff);
		return d.toISOString().split('T')[0];
	},

	/**
	 * Переключение формата (онлайн/офлайн)
	 */
	switchFormat: function(format) {
		this.currentFormat = format;

		// Обновляем активный таб
		document.querySelectorAll('[data-psy-schedule-format]').forEach(el => {
			el.classList.toggle('active', el.dataset.psyScheduleFormat === format);
		});

		this.loadWeekData();
	},

	/**
	 * Предыдущая неделя
	 */
	prevWeek: function() {
		const d = new Date(this.currentWeekStart);
		d.setDate(d.getDate() - 7);
		this.currentWeekStart = d.toISOString().split('T')[0];
		this.loadWeekData();
	},

	/**
	 * Следующая неделя
	 */
	nextWeek: function() {
		const d = new Date(this.currentWeekStart);
		d.setDate(d.getDate() + 7);
		this.currentWeekStart = d.toISOString().split('T')[0];
		this.loadWeekData();
	},

	/**
	 * Текущая неделя
	 */
	goToCurrentWeek: function() {
		this.currentWeekStart = this.getMondayOfWeek(new Date());
		this.loadWeekData();
	},

	/**
	 * Загрузка данных недели
	 */
	loadWeekData: function() {
		const grid = document.getElementById('psy-schedule-grid');
		if (!grid) return;

		grid.classList.add('loading');

		this.ajax('get_week_data', {
			week_start: this.currentWeekStart,
			format: this.currentFormat
		})
		.then(res => {
			if (res.success) {
				this.renderGrid(res);
				this.updateWeekNavigation(res.week_start, res.week_end);
			}
		})
		.finally(() => {
			grid.classList.remove('loading');
		});
	},

	/**
	 * Отрисовка сетки
	 */
	renderGrid: function(data) {
		const grid = document.getElementById('psy-schedule-grid');
		if (!grid) return;

		let html = '<table class="schedule-grid">';

		// Заголовок с днями
		html += '<thead><tr><th class="schedule-grid__hour-header">Время</th>';
		data.days.forEach(day => {
			const todayClass = day.is_today ? ' schedule-grid__day--today' : '';
			html += `<th class="schedule-grid__day-header${todayClass}" data-date="${day.date}">
				<div class="schedule-grid__weekday">${day.weekday_name}</div>
				<div class="schedule-grid__date">${day.day_of_month}</div>
				<button class="schedule-grid__add-btn" data-date="${day.date}" title="Добавить доступность">+</button>
			</th>`;
		});
		html += '</tr></thead>';

		// Строки с временными слотами (30 минут)
		html += '<tbody>';
		data.hours.forEach((timeSlot, slotIndex) => {
			// Определяем полный час или полчаса
			const isHour = timeSlot.is_hour;
			const rowClass = isHour ? 'schedule-grid__row--hour' : 'schedule-grid__row--half';

			html += `<tr class="${rowClass}">`;

			// Показываем время только для полных часов
			if (isHour) {
				html += `<td class="schedule-grid__hour" rowspan="2">${timeSlot.time}</td>`;
			}

			data.days.forEach((day, dayIndex) => {
				const slot = day.slots[slotIndex];
				let slotClass = `schedule-grid__slot schedule-grid__slot--${slot.status}`;
				const title = slot.status_text || '';

				// Определяем позицию слота внутри многослотовой записи
				let isBookingFirst = false;
				let isBookingMid = false;
				let isBookingLast = false;

				if (slot.status === 'booked' && slot.appointment) {
					const aptId = slot.appointment.id;
					const prevSlot = slotIndex > 0 ? day.slots[slotIndex - 1] : null;
					const nextSlot = slotIndex < day.slots.length - 1 ? day.slots[slotIndex + 1] : null;
					const prevSameApt = prevSlot && prevSlot.appointment && prevSlot.appointment.id === aptId;
					const nextSameApt = nextSlot && nextSlot.appointment && nextSlot.appointment.id === aptId;

					if (!prevSameApt && nextSameApt) {
						isBookingFirst = true;
						slotClass += ' schedule-grid__slot--booking-first';
					} else if (prevSameApt && nextSameApt) {
						isBookingMid = true;
						slotClass += ' schedule-grid__slot--booking-mid';
					} else if (prevSameApt && !nextSameApt) {
						isBookingLast = true;
						slotClass += ' schedule-grid__slot--booking-last';
					} else {
						// Единственный слот записи — показываем как обычно
						slotClass += ' schedule-grid__slot--booking-single';
					}
				}

				html += `<td class="${slotClass}"
					data-date="${day.date}"
					data-time="${timeSlot.time}"
					data-status="${slot.status}"
					data-availability-id="${slot.availability_id || ''}"
					data-appointment-id="${slot.appointment ? slot.appointment.id : ''}"
					title="${title}">`;

				if (slot.status === 'booked' && slot.appointment) {
					const fmt = slot.appointment.format === 'офлайн' ? 'Очно' : 'Онлайн';
					// Имя клиента показываем только в первом слоте записи (или единственном)
					if (isBookingFirst) {
						html += `<div class="schedule-grid__booking">
							<span class="schedule-grid__client">${slot.appointment.client_name}</span>
						</div>`;
					} else if (!isBookingMid && !isBookingLast) {
						// Единственный слот — имя + формат
						html += `<div class="schedule-grid__booking">
							<span class="schedule-grid__client">${slot.appointment.client_name}</span>
							<span class="schedule-grid__format">${fmt}</span>
						</div>`;
					} else if (isBookingMid || isBookingLast) {
						// Второй слот — показываем формат записи
						const prevSlotData = day.slots[slotIndex - 1];
						const prevIsFirst = prevSlotData && prevSlotData.appointment && prevSlotData.appointment.id === slot.appointment.id
							&& (slotIndex < 2 || !day.slots[slotIndex - 2].appointment || day.slots[slotIndex - 2].appointment.id !== slot.appointment.id);
						if (prevIsFirst) {
							html += `<div class="schedule-grid__booking">
								<span class="schedule-grid__format">${fmt}</span>
							</div>`;
						}
					}
				} else if (slot.status === 'available') {
					html += `<div class="schedule-grid__available">
						<button class="schedule-grid__delete-btn" type="button" title="Удалить доступность">×</button>
					</div>`;
				} else if (slot.status === 'cabinet_busy') {
					html += `<div class="schedule-grid__busy">${slot.status_text}</div>`;
				}

				html += '</td>';
			});

			html += '</tr>';
		});
		html += '</tbody></table>';

		grid.innerHTML = html;

		// Привязываем события к слотам
		this.bindSlotEvents();

		// Инициализируем drag-выделение
		this.initDragSelection();
	},

	/**
	 * Привязка событий к слотам
	 */
	bindSlotEvents: function() {
		// Клик на заголовок дня (добавить доступность)
		document.querySelectorAll('.schedule-grid__add-btn').forEach(btn => {
			btn.addEventListener('click', (e) => {
				e.stopPropagation();
				this.openAvailabilityPopup(btn.dataset.date);
			});
		});

		// Крестик для быстрого удаления на available слотах
		document.querySelectorAll('.schedule-grid__slot--available .schedule-grid__delete-btn').forEach(btn => {
			btn.addEventListener('click', (e) => {
				e.stopPropagation();
				e.preventDefault();
				const slot = btn.closest('.schedule-grid__slot');
				this.confirmRemoveAvailability(slot.dataset.availabilityId);
			});
			// Также останавливаем mousedown, чтобы не запускался drag
			btn.addEventListener('mousedown', (e) => {
				e.stopPropagation();
				e.preventDefault();
			});
		});

		// Клик на booked слот — показать детали записи
		document.querySelectorAll('.schedule-grid__slot--booked').forEach(slot => {
			slot.addEventListener('click', () => {
				var appointmentId = slot.dataset.appointmentId;
				if (appointmentId && window.PsyAppointments) {
					PsyAppointments.openPopup(appointmentId);
				}
			});
		});
	},

	/**
	 * Открытие попапа доступности
	 */
	openAvailabilityPopup: function(date, time, endTime) {
		const popup = document.getElementById('popup-psy-availability');
		if (!popup) return;

		const form = document.getElementById('psy-availability-form');

		// Сброс формы
		form.reset();
		form.querySelector('[name="date"]').value = date;
		form.querySelector('[name="sel_format"]').value = this.currentFormat;

		// Устанавливаем время
		if (time) {
			form.querySelector('[name="tme_begin"]').value = time;
			// Если endTime не передан, добавляем 30 минут
			if (endTime) {
				form.querySelector('[name="tme_end"]').value = endTime;
			} else {
				form.querySelector('[name="tme_end"]').value = this.addMinutes(time, 30);
			}
		} else {
			form.querySelector('[name="tme_begin"]').value = '09:00';
			form.querySelector('[name="tme_end"]').value = '18:00';
		}

		// Обновляем заголовок с датой
		const title = popup.querySelector('.popup__title');
		if (title) {
			const d = new Date(date);
			const options = { weekday: 'long', day: 'numeric', month: 'long' };
			title.textContent = 'Доступность: ' + d.toLocaleDateString('ru-RU', options);
		}

		popup.classList.add('active');
	},

	/**
	 * Добавить минуты к времени
	 */
	addMinutes: function(time, minutes) {
		const [h, m] = time.split(':').map(Number);
		const totalMinutes = h * 60 + m + minutes;
		const newH = Math.floor(totalMinutes / 60) % 24;
		const newM = totalMinutes % 60;
		return String(newH).padStart(2, '0') + ':' + String(newM).padStart(2, '0');
	},

	/**
	 * Закрытие попапов
	 */
	closePopups: function() {
		document.querySelectorAll('.popup-psy-availability').forEach(popup => {
			popup.classList.remove('active');
		});
	},

	/**
	 * Сохранение доступности
	 */
	saveAvailability: function(form) {
		const formData = new FormData(form);
		formData.append('action', 'set_availability');

		const submitBtn = form.querySelector('button[type="submit"]');
		this.setLoading(submitBtn, true);

		fetch('/ajax.php?mid=' + this.moduleId, {
			method: 'POST',
			body: formData
		})
		.then(res => res.json())
		.then(res => {
			if (res.success) {
				this.closePopups();
				this.loadWeekData();
			} else {
				alert(res.error || 'Ошибка сохранения');
			}
		})
		.finally(() => {
			this.setLoading(submitBtn, false);
		});
	},

	/**
	 * Подтверждение и удаление доступности
	 */
	confirmRemoveAvailability: function(availabilityId) {
		if (!availabilityId) return;

		// Находим все слоты с этим availability_id для сбора информации
		const slots = document.querySelectorAll(`[data-availability-id="${availabilityId}"]`);
		if (slots.length === 0) return;

		// Берём первый слот для получения даты и времени
		const firstSlot = slots[0];
		const date = firstSlot.dataset.date;

		// Находим минимальное и максимальное время
		let minTime = '23:59';
		let maxTime = '00:00';
		slots.forEach(slot => {
			const time = slot.dataset.time;
			if (time < minTime) minTime = time;
			if (time > maxTime) maxTime = time;
		});

		// Конечное время = последний слот + 30 минут
		const endTime = this.addMinutes(maxTime, 30);

		// Форматируем дату для confirm
		const d = new Date(date);
		const dateStr = d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', weekday: 'long' });

		const message = `Удалить доступность?\n\n${dateStr}\nВремя: ${minTime} — ${endTime}\nФормат: ${this.currentFormat}`;

		if (confirm(message)) {
			this.removeAvailability(availabilityId);
		}
	},

	/**
	 * Удаление доступности
	 */
	removeAvailability: function(id) {
		this.ajax('remove_availability', { id: id })
			.then(res => {
				if (res.success) {
					this.loadWeekData();
				} else {
					alert(res.error || 'Ошибка удаления');
				}
			});
	},

	/**
	 * Обновление навигации по неделям
	 */
	updateWeekNavigation: function(weekStart, weekEnd) {
		const dateRange = document.getElementById('psy-schedule-date-range');
		if (dateRange) {
			const start = new Date(weekStart);
			const end = new Date(weekEnd);
			const options = { day: 'numeric', month: 'short' };

			dateRange.textContent = start.toLocaleDateString('ru-RU', options) + ' — ' + end.toLocaleDateString('ru-RU', options);
		}
	},

	/**
	 * AJAX запрос
	 */
	ajax: function(action, data = {}) {
		const formData = new FormData();
		formData.append('action', action);

		for (const key in data) {
			formData.append(key, data[key]);
		}

		return fetch('/ajax.php?mid=' + this.moduleId, {
			method: 'POST',
			body: formData
		}).then(res => res.json());
	},

	/**
	 * Состояние загрузки
	 */
	setLoading: function(button, loading) {
		if (!button) return;

		if (loading) {
			button.disabled = true;
			button.dataset.originalText = button.textContent;
			button.textContent = 'Сохранение...';
		} else {
			button.disabled = false;
			button.textContent = button.dataset.originalText || button.textContent;
		}
	},

	/**
	 * Инициализация drag-выделения
	 */
	initDragSelection: function() {
		const self = this;
		const grid = document.getElementById('psy-schedule-grid');
		if (!grid) return;

		// Начало выделения
		grid.addEventListener('mousedown', function(e) {
			// Игнорируем клики на крестик удаления
			if (e.target.closest('.schedule-grid__delete-btn')) {
				return;
			}

			const cell = e.target.closest('.schedule-grid__slot');
			if (!cell) return;

			// Не начинаем выделение на занятых слотах
			const status = cell.dataset.status;
			if (status === 'booked') return;

			e.preventDefault();
			self.isDragging = true;
			self.dragStartCell = cell;
			self.selectedCells = [cell];
			self.updateSelection();
		});

		// Продолжение выделения
		grid.addEventListener('mouseover', function(e) {
			if (!self.isDragging) return;

			const cell = e.target.closest('.schedule-grid__slot');
			if (!cell) return;

			// Не включаем занятые слоты
			const status = cell.dataset.status;
			if (status === 'booked') return;

			// Выбираем прямоугольную область
			self.selectRectangle(self.dragStartCell, cell);
		});

		// Окончание выделения
		document.addEventListener('mouseup', function(e) {
			if (!self.isDragging) return;

			self.isDragging = false;

			if (self.selectedCells.length > 0) {
				self.onSelectionComplete();
			}
		});

		// Предотвращаем выделение текста при drag
		grid.addEventListener('selectstart', function(e) {
			if (self.isDragging) {
				e.preventDefault();
			}
		});
	},

	/**
	 * Выбор прямоугольной области
	 * Используем data-date и data-time вместо cellIndex,
	 * т.к. rowspan на ячейках времени сдвигает cellIndex в чётных/нечётных строках
	 */
	selectRectangle: function(startCell, endCell) {
		const grid = document.getElementById('psy-schedule-grid');

		// Получаем координаты через data-атрибуты
		const startDate = startCell.dataset.date;
		const startTime = startCell.dataset.time;
		const endDate = endCell.dataset.date;
		const endTime = endCell.dataset.time;

		// Собираем все уникальные даты и времена из сетки для определения порядка
		const allSlots = grid.querySelectorAll('.schedule-grid__slot');
		const dateOrder = [];
		const timeOrder = [];

		allSlots.forEach(slot => {
			const d = slot.dataset.date;
			const t = slot.dataset.time;
			if (dateOrder.indexOf(d) === -1) dateOrder.push(d);
			if (timeOrder.indexOf(t) === -1) timeOrder.push(t);
		});

		dateOrder.sort();
		timeOrder.sort();

		// Определяем диапазон дат и времён
		const startDateIdx = dateOrder.indexOf(startDate);
		const endDateIdx = dateOrder.indexOf(endDate);
		const startTimeIdx = timeOrder.indexOf(startTime);
		const endTimeIdx = timeOrder.indexOf(endTime);

		const minDateIdx = Math.min(startDateIdx, endDateIdx);
		const maxDateIdx = Math.max(startDateIdx, endDateIdx);
		const minTimeIdx = Math.min(startTimeIdx, endTimeIdx);
		const maxTimeIdx = Math.max(startTimeIdx, endTimeIdx);

		this.selectedCells = [];

		allSlots.forEach(slot => {
			const dIdx = dateOrder.indexOf(slot.dataset.date);
			const tIdx = timeOrder.indexOf(slot.dataset.time);

			if (dIdx >= minDateIdx && dIdx <= maxDateIdx &&
			    tIdx >= minTimeIdx && tIdx <= maxTimeIdx) {
				if (slot.dataset.status !== 'booked') {
					this.selectedCells.push(slot);
				}
			}
		});

		this.updateSelection();
	},

	/**
	 * Обновление визуального выделения
	 */
	updateSelection: function() {
		// Убираем выделение со всех
		document.querySelectorAll('.schedule-grid__slot--selected').forEach(el => {
			el.classList.remove('schedule-grid__slot--selected');
		});

		// Добавляем выделение к выбранным
		this.selectedCells.forEach(cell => {
			cell.classList.add('schedule-grid__slot--selected');
		});
	},

	/**
	 * Завершение выделения
	 */
	onSelectionComplete: function() {
		if (this.selectedCells.length === 0) return;

		// Анализируем выделенные ячейки
		const dates = new Set();
		const times = [];
		const availabilityIds = new Set();
		const statuses = new Set();

		this.selectedCells.forEach(cell => {
			dates.add(cell.dataset.date);
			times.push(cell.dataset.time);
			statuses.add(cell.dataset.status);
			if (cell.dataset.availabilityId) {
				availabilityIds.add(cell.dataset.availabilityId);
			}
		});

		times.sort();

		// Проверка 1: Несколько дней
		if (dates.size > 1) {
			alert('Выбрано несколько дней. Выделите слоты в пределах одного дня.');
			this.selectedCells = [];
			this.updateSelection();
			return;
		}

		const date = dates.values().next().value;
		const startTime = times[0];
		const endTime = this.addMinutes(times[times.length - 1], 30);

		// Проверка 2: Все ячейки available и один availability_id → УДАЛЕНИЕ
		if (statuses.size === 1 && statuses.has('available') && availabilityIds.size === 1) {
			const availabilityId = availabilityIds.values().next().value;
			this.confirmRemoveAvailability(availabilityId);
		}
		// Проверка 3: Несколько разных availability_id
		else if (availabilityIds.size > 1) {
			alert('Выделено несколько разных интервалов доступности. Выделите один интервал для удаления или пустые слоты для добавления.');
		}
		// Проверка 4: Есть пустые слоты (unavailable или '') → ДОБАВЛЕНИЕ
		else if (statuses.has('unavailable') || statuses.has('')) {
			this.openAvailabilityPopup(date, startTime, endTime);
		}
		// Проверка 5: Есть booked
		else if (statuses.has('booked')) {
			alert('В выделении есть занятые слоты. Выделите только доступные или свободные слоты.');
		}

		// Очищаем выделение
		this.selectedCells = [];
		this.updateSelection();
	}
};

// Инициализация при загрузке DOM
$(document).ready(function() {
	PsySchedule.init();
});

window.PsySchedule = PsySchedule;
